import { CurrencyPicker } from 'pricing-pages-ui-components/currency-picker/CurrencyPicker';
import { validateCurrencyCode } from '../../utils/currencyUtils';
import { useGetCurrencyStore, useSetCurrencyStore } from '../../context/CurrencyContext';
import { useAvailableCurrencyCodes, useDisplayedCurrencyCode } from '../hooks/pricing/useCurrencyDetails';
import { trackCurrencyPickerInteraction } from '../utils/tracking/trackingEventUtils';
import { isAvailableCurrencyCode } from '../utils/typeguards';
import { useQueryParamCurrency } from '../utils/urls/appQueryParamUtils';
import { useCurrencyInitialization, useCurrencyQueryParamSync } from './hooks/useCurrencyPicker';
import { jsx as _jsx } from "react/jsx-runtime";
export const CurrencyPickerContainer = () => {
  const setCurrencyStore = useSetCurrencyStore();
  const {
    availableCurrencyCodes,
    lockedCurrencyCode,
    displayedCurrencyCode
  } = useGetCurrencyStore(store => store);
  const currencyCode = useDisplayedCurrencyCode();
  const availableCurrencies = useAvailableCurrencyCodes();
  const {
    setQueryParamCurrency
  } = useQueryParamCurrency();

  // Use custom hooks for currency initialization and query param synchronization
  const hasInitialized = useCurrencyInitialization();
  useCurrencyQueryParamSync(hasInitialized);
  const handleChange = ({
    target: {
      value: selectedCurrencyCode
    }
  }) => {
    const isValidCurrencyCode = isAvailableCurrencyCode(selectedCurrencyCode);
    if (!isValidCurrencyCode) {
      return;
    }
    const validatedCurrencyCode = validateCurrencyCode({
      availableCurrencyCodes,
      lockedCurrencyCode,
      displayedCurrencyCode,
      currencyCode: selectedCurrencyCode
    });
    if (!isAvailableCurrencyCode(validatedCurrencyCode)) {
      return;
    }
    const showCurrencyCodeUnit = validatedCurrencyCode === 'USD';
    setCurrencyStore({
      displayedCurrencyCode: validatedCurrencyCode,
      showCurrencyCodeUnit
    });
    setQueryParamCurrency(validatedCurrencyCode);
    trackCurrencyPickerInteraction({
      action: 'select currency',
      currency: validatedCurrencyCode
    });
  };
  const shouldShowSelector = availableCurrencyCodes && availableCurrencyCodes.length > 1;
  if (!shouldShowSelector) {
    return /*#__PURE__*/_jsx("span", {
      style: {
        minHeight: '40px'
      }
    });
  }
  return /*#__PURE__*/_jsx(CurrencyPicker, {
    availableCurrencies: availableCurrencies,
    selectedCurrency: currencyCode,
    onChange: handleChange
  });
};